import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import Layout from "./Layout";
import { GlobalStyle } from "../pages/HomePage";

const PageHeader = styled.div`
  background: var(--bg);
  border-bottom: 1px solid var(--border);
  padding: 1.5rem 0;
`;

const HeaderInner = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 0 1rem;
  @media (min-width: 640px) { padding: 0 1.5rem; }
  @media (min-width: 1024px) { padding: 0 2rem; }
`;

const Breadcrumb = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8rem;
  color: var(--text-muted);
  margin-bottom: 0.5rem;
`;

const BreadcrumbLink = styled(Link)`
  color: var(--link);
  text-decoration: none;
  &:hover { text-decoration: underline; }
`;

const PageTitle = styled.h1`
  font-size: 1.875rem;
  font-weight: 500;
  color: var(--text-primary);
  margin: 0;
`;

const Subtitle = styled.p`
  font-size: 0.875rem;
  color: var(--text-muted);
  margin: 0.25rem 0 0;
`;

const PageBody = styled.section`
  padding: 2.5rem 0 3rem;
  background: var(--bg-secondary);
`;

const BodyInner = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 0 1rem;
  color: var(--text-primary);
  line-height: 1.7;
  font-size: 1rem;

  h2 {
    font-size: 1.25rem;
    font-weight: 500;
    color: var(--text-primary);
    margin: 2rem 0 0.75rem;
  }

  h3 {
    font-size: 1.05rem;
    font-weight: 500;
    color: var(--text-primary);
    margin: 1.5rem 0 0.5rem;
  }

  p { margin: 0 0 1rem; }

  ul {
    margin: 0 0 1rem;
    padding-left: 1.25rem;
  }

  li { margin-bottom: 0.35rem; }

  a {
    color: var(--link);
    text-decoration: none;
    &:hover { text-decoration: underline; }
  }

  @media (min-width: 640px) { padding: 0 1.5rem; }
  @media (min-width: 1024px) { padding: 0 2rem; }
`;

const StaticPage = ({ title, subtitle, breadcrumb, children }) => (
  <>
    <GlobalStyle />
    <Layout>
      <PageHeader>
        <HeaderInner>
          <Breadcrumb>
            <BreadcrumbLink to="/">Home</BreadcrumbLink>
            <span>›</span>
            <span>{breadcrumb || title}</span>
          </Breadcrumb>
          <PageTitle>{title}</PageTitle>
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
        </HeaderInner>
      </PageHeader>
      <PageBody>
        <BodyInner>{children}</BodyInner>
      </PageBody>
    </Layout>
  </>
);

export default StaticPage;
